/**
 * mobile nav
 */

const nav = document.querySelector('.js-nav');
const navTriggers = document.querySelectorAll('.js-nav-trigger');

navTriggers.forEach(trigger => {
	trigger.addEventListener('click', function (e) {
		navTriggers.forEach(navTrigger => {
			navTrigger.classList.toggle('is-active');
		})
		nav.classList.toggle('is-active');

		e.preventDefault();
	})
})
